import React from "react";
import { ReactHookFormInput } from "../../../nuup/componentes/Forms/ReactHookFormInput.jsx";
import CalidadAnalisisFisicoZarandas from "../calidad-analisis-fisico-zarandas.js";
import CalidadAnalisisFisicoDefectos from "../calidad-analisis-fisico-defectos.js";
import {
  calcRendimientoExportableDesdeLimpio,
  calcPesoCafeLimpioPorZarandas,
} from "./calidad-calculos.js";

const CalidadAnalisisOro = ({
  control,
  errors,
  getValues,
  register,
  defaultValues,
  setValue,
  onOroDerivedRecalc,
}) => {
  const oroVals = getValues()?.analisis_oro || {};
  const prim = Array.isArray(oroVals?.defectos_primarios)
    ? oroVals.defectos_primarios
    : [];
  const sec = Array.isArray(oroVals?.defectos_secundarios)
    ? oroVals.defectos_secundarios
    : [];
  const sumIntermedio = [...prim, ...sec].reduce(
    (acc, d) => acc + (Number(d?.defectos ?? 0) || 0),
    0
  );
  const sumIntermedioFmt =
    sumIntermedio > 0 ? Number(sumIntermedio.toFixed(2)) : "";
  const sumFinal = sumIntermedio > 0 ? Math.ceil(sumIntermedio) : "";

  // Cálculos de referencia (no rellenan inputs, sólo muestran en etiquetas)
  const entries = Array.isArray(oroVals?.zarandas) ? oroVals.zarandas : [];
  const totalDefectosGr = oroVals?.total_defectos_gramos;
  const pesoMuestraPergamino = Number(getValues()?.analisis_fisico?.pergamino_peso_muestra_pergamino);
  const pesoCafeLimpioCalc = calcPesoCafeLimpioPorZarandas(entries, totalDefectosGr, [1]);
  const rendimientoExportableCalc = calcRendimientoExportableDesdeLimpio(pesoMuestraPergamino, pesoCafeLimpioCalc);

  return (
    <>
      <div className="row mt-3">
        <div className="col-xs-12 col-lg-4">
          <ReactHookFormInput
            type="number"
            id="analisis_oro.pergamino_peso_muestra_oro_2"
            name="analisis_oro.pergamino_peso_muestra_oro_2"
            label="Peso de la muestra oro (grs.)"
            error={errors?.analisis_oro?.pergamino_peso_muestra_oro_2}
            control={control}
            value={getValues()?.analisis_oro?.pergamino_peso_muestra_oro_2}
            onBlurExternal={
              typeof onOroDerivedRecalc === "function"
                ? onOroDerivedRecalc
                : undefined
            }
          />
        </div>
      </div>

      {/* Zarandas */}
      <CalidadAnalisisFisicoZarandas
        {...{
          control,
          register,
          defaultValues,
          getValues,
          setValue,
          errors,
          onBlurRecalc: onOroDerivedRecalc,
        }}
      />

      {/* Defectos primarios */}
      <div className="row mt-3">
        <div className="col-lg-12">
          <CalidadAnalisisFisicoDefectos
            type={"analisis_oro.defectos_primarios"}
            {...{ control, register, getValues, setValue, errors }}
          />
        </div>
      </div>

      {/* Defectos secundarios */}
      <div className="row mt-3">
        <div className="col-lg-12">
          <CalidadAnalisisFisicoDefectos
            type={"analisis_oro.defectos_secundarios"}
            {...{ control, register, getValues, setValue, errors }}
          />
        </div>
      </div>

      {/* Resumen de defectos: línea única con final e intermedio */}
      <div className="row mt-3">
        <div className="col-lg-3">
          <span style={{}}>{`Intermedios (suma): ${sumIntermedioFmt ??
            "-"}`}</span>
        </div>
        <div className="col-lg-3">
          <span>
            {"Defectos finales (redondeo hacia arriba) : " +
              String(sumFinal ?? "-")}
          </span>
        </div>
      </div>

      {/* Total de defectos (grs.) y Pérdida por procesamiento (%) en 6 columnas */}
      <div className="row mt-3">
        <div className="col-xs-12 col-lg-5">
          <ReactHookFormInput
            type="number"
            id="analisis_oro.total_defectos_gramos"
            name="analisis_oro.total_defectos_gramos"
            label="Total de defectos (grs.)"
            error={errors?.analisis_oro?.total_defectos_gramos}
            control={control}
            value={getValues()?.analisis_oro?.total_defectos_gramos}
            onBlurExternal={
              typeof onOroDerivedRecalc === "function"
                ? onOroDerivedRecalc
                : undefined
            }
          />
        </div>
        <div className="col-lg-3"></div>
      </div>

      <div className="row mt-3">
        <div className="col-xs-12 col-lg-5">

          <div style={{ paddingTop: 10 }}>
            <ReactHookFormInput
              type="number"
              id="analisis_oro.peso_cafe_limpio_grs"
              name="analisis_oro.peso_cafe_limpio_grs"
              label="Peso de café limpio (grs)"
              error={errors?.analisis_oro?.peso_cafe_limpio_grs}
              control={control}
              value={getValues()?.analisis_oro?.peso_cafe_limpio_grs}
              onBlurExternal={
                typeof onOroDerivedRecalc === "function"
                  ? onOroDerivedRecalc
                  : undefined
              }
            />
          </div>
        </div>
                <div className="col-lg-3">
                  {pesoCafeLimpioCalc !== "" && !isNaN(Number(pesoCafeLimpioCalc)) && Number(pesoCafeLimpioCalc) > 0 ? (
                    <p style={{ fontWeight: "bold", paddingTop: 20 }}>{`Peso café limpio (grs.): ${Number(pesoCafeLimpioCalc).toFixed(2)}`}</p>
                  ) : null}
                </div>
      </div>

      <div className="row mt-3">
        <div className="col-xs-12 col-lg-5">

          <div style={{ paddingTop: 10 }}>
            <ReactHookFormInput
              type="number"
              id="analisis_oro.rendimiento_exportable_por"
              name="analisis_oro.rendimiento_exportable_por"
              label="Rendimiento exportable (%)"
              error={errors?.analisis_oro?.rendimiento_exportable_por}
              control={control}
              value={getValues()?.analisis_oro?.rendimiento_exportable_por}
              onBlurExternal={
                typeof onOroDerivedRecalc === "function"
                  ? onOroDerivedRecalc
                  : undefined
              }
            />
          </div>
        </div>
                <div className="col-xs-12 col-lg-6">
                  {rendimientoExportableCalc !== "" && !isNaN(Number(rendimientoExportableCalc)) && Number(rendimientoExportableCalc) > 0 ? (
                    <p style={{ fontWeight: "bold", paddingTop: 20 }}>{`Rendimiento exportable (%): ${Number(rendimientoExportableCalc).toFixed(2)}`}</p>
                  ) : null}
                </div>
      </div>

      <div className="row mt-3">
        <div className="col-xs-12 col-lg-5">
          <ReactHookFormInput
            type="number"
            id="analisis_oro.perdida_procesamiento_por"
            name="analisis_oro.perdida_procesamiento_por"
            label="Pérdida por procesamiento (%)"
            error={errors?.analisis_oro?.perdida_procesamiento_por}
            control={control}
            value={getValues()?.analisis_oro?.perdida_procesamiento_por}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xs-12 col-lg-6">
          <span
            style={{ fontWeight: "bold", paddingBottom: 100, paddingTop: 10 }}
          >{`Rendimiento real (%): ${getValues()?.analisis_oro
            ?.rendimiento_exportable_por -
            getValues()?.analisis_oro?.perdida_procesamiento_por}`}</span>
        </div>
      </div>
    </>
  );
};

export default CalidadAnalisisOro;
